export default __webpack_public_path__ + "static/media/thumbnail.a8405dd9.jpg";